import { View as MnView } from "extensions/marionette";
import { Backbone } from "extensions/backbone";

import { Loader } from "common/components/loader";
import _loadingTemplate from "./loader.jst";

export const Model = Backbone.Model.extend({
    defaults: {
        colspan: 1,
        message: ""
    }
});

export const View = MnView.extend({
    template: _loadingTemplate,
    tagName: "tr",
    className: "table-information-row",
    ui: {
        message: ".message"
    },
    events: {
        "click .retry-page": function() {
            this.trigger("refresh");
        }
    },
    modelEvents: {
        "change:message": "showMessage"
    },
    onRender() {
        if (this.model && this.model.get("message")) return;
        Loader.addTo(this.ui.message);
    },
    removeLoader() {
        Loader.removeFrom(this.ui.message);
    },
    showMessage() {
        this.removeLoader();
        this.render();
    },
    onBeforeDestroy() {
        this.removeLoader();
    }
});
